/**
 * Sierra Leone Mpox Tracker - Web Application
 * Entry point for the mobile-first, offline-capable web dashboard
 */

import '@/styles/main.css';
import { AppController } from '@/components/AppController';
import { ApiService } from '@/api/ApiService';
import { StorageService } from '@/utils/StorageService';

// Initialize app when DOM is ready
document.addEventListener('DOMContentLoaded', async () => {
    const loadingElement = document.getElementById('loading');
    const appElement = document.getElementById('app');
    
    if (!appElement) {
        console.error('App element not found');
        return;
    }
    
    try {
        // Initialize services
        const apiService = new ApiService();
        const storageService = new StorageService();
        
        // Initialize app controller
        const app = new AppController(appElement, apiService, storageService);
        
        // Load initial data
        await app.initialize();
        
        // Hide loading screen and show app
        if (loadingElement) {
            loadingElement.classList.add('hidden');
        }
        appElement.classList.add('visible');
        
        console.log('🇸🇱 Sierra Leone Mpox Tracker initialized');
        
    } catch (error) {
        console.error('Failed to initialize app:', error);
        
        // Show error state
        if (loadingElement) {
            loadingElement.innerHTML = `
                <div class="loading-spinner" style="border-top-color: #ef4444;"></div>
                <div class="loading-text" style="color: #ef4444;">Connection Error</div>
                <div class="loading-subtitle">
                    Unable to load data. Please check your connection and refresh.
                    <br><br>
                    <button onclick="location.reload()" style="
                        background: white; 
                        color: #ef4444; 
                        border: none; 
                        padding: 0.5rem 1rem; 
                        border-radius: 0.25rem;
                        cursor: pointer;
                        font-weight: 600;
                    ">Try Again</button>
                </div>
            `;
        }
    }
});

// Handle app visibility changes for data refresh
document.addEventListener('visibilitychange', () => {
    if (!document.hidden) {
        // App became visible - refresh data if needed
        const event = new CustomEvent('app:refresh');
        document.dispatchEvent(event);
    }
});

// Handle online/offline status
window.addEventListener('online', () => {
    const event = new CustomEvent('app:online');
    document.dispatchEvent(event);
});

window.addEventListener('offline', () => {
    const event = new CustomEvent('app:offline');
    document.dispatchEvent(event);
});